/* eslint-disable react/no-unescaped-entities */
import MailTo from "components/errors/MailTo";
import PolicyPage from "components/policies/PolicyPage";
import FundamenteiMetadata from "components/seo/FundamenteiMetadata";
import parse from "date-fns/parse";

function AntiScrapingTerms() {
  return (
    <>
      <FundamenteiMetadata title="Termos e Condições Anti-Scraping | Fundamentei" />
      <PolicyPage
        title="Termos e Condições Anti-Scraping"
        lastUpdatedAt={parse("2023-10-25", "yyyy-MM-dd", new Date())}
      >
        <div className="prose prose-gray max-w-none p-4 lg:prose-lg">
          <p>
            A Fundamentei Serviços de Informação LTDA (“Nós”), CNPJ 35.804.692/0001-05, estabelece as diretrizes e
            regras para o uso de qualquer conteúdo disponibilizado por nós e proíbe atividades de scraping não
            autorizadas. Ao acessar ou utilizar qualquer conteúdo fornecido por nós, você concorda com estes Termos.
            Orientamos a leitura com atenção.
          </p>
          <ul>
            <li className="list-none">
              <strong>1. Definições</strong>
            </li>
            <li>
              <p>
                1.1. Scraping se refere à prática de coletar automaticamente, por meio de ferramentas e outros
                mecanismos, informações de um site ou recurso online, comumente sem a permissão do proprietário do site.
              </p>
            </li>
            <li>
              <p>
                1.2. Usuário: Você, a pessoa ou entidade que acessa, utiliza, ou tenta acessar ou utilizar qualquer
                conteúdo fornecido por nós.
              </p>
            </li>
            <li className="list-none">
              <strong>2. Proibição de Scraping Não Autorizado</strong>
            </li>
            <li>
              <p>
                2.1. Você concorda em não se envolver em scraping não autorizado de qualquer conteúdo disponibilizado
                por nós. Isso inclui a coleta, cópia, distribuição, exibição, publicação, ou qualquer outra forma de
                obtenção de informações de nossos recursos de forma automatizada sem nossa autorização expressa.
              </p>
            </li>
            <li className="list-none">
              <strong>3. Uso Autorizado</strong>
            </li>
            <li>
              <p>
                3.1. Qualquer uso autorizado do conteúdo fornecido por Nós será realizado de forma expressa e
                inequívoca. O uso autorizado estará sujeito a termos e condições específicas que serão previstos em
                documento próprio.
              </p>
            </li>
            <li className="list-none">
              <strong>4. Detecção e Consequências</strong>
            </li>
            <li>
              <p>
                4.1. Considerando que nós adotamos conduta absoluta e totalmente contrária à prática de scraping, não
                haverá qualquer tolerância ou condicional quando da identificação desta prática pelo usuário, de modo
                que não hesitaremos em tomar as medidas cabíveis ao nosso alcance.
              </p>
            </li>
            <li>
              <p>
                4.2. Reservamo-nos o direito de monitorar, detectar e responder a atividades de scraping não autorizado.
                Isso pode incluir o bloqueio de endereços IP, cancelamento de assinatura, bloqueio de contas e entre
                outras medidas para prevenir a continuação dessas atividades.
              </p>
            </li>
            <li>
              <p>
                4.3. A violação destes Termos sujeitará você a medidas legais, incluindo, mas não se limitando a, ações
                judiciais para fazer valer nossos direitos e buscar reparação por danos, tanto em âmbito civil quanto
                criminal.
              </p>
            </li>
            <li>
              <p>
                4.4. O usuário se declara ciente que, ao identificar a prática de scraping, poderemos compartilhar os
                dados de acesso (IP, agente de usuário, localização e entre outros) do usuário com terceiros caso assim
                seja necessário para fins de análise da prática.
              </p>
            </li>
            <li className="list-none">
              <strong>5. Denúncias e Notificação de Violação</strong>
            </li>
            <li>
              <p>
                5.1. Se você acredita que o scraping não autorizado de nosso conteúdo está ocorrendo, entre em contato
                conosco por meio do seguinte endereço de e-mail: <MailTo address="contato@fundamentei.com" />. Tomaremos
                as medidas recomendadas para investigar e corrigir qualquer violação detectada.
              </p>
            </li>
            <li className="list-none">
              <strong>6. Alterações nos Termos</strong>
            </li>
            <li>
              <p>
                6.1. Reservamo-nos o direito de alterar estes Termos a qualquer momento. Quaisquer alterações serão
                publicadas em nosso site ou por meio de outras formas de comunicação. O uso contínuo de nosso conteúdo
                após a implementação de alterações significará sua aceitação dessas alterações.
              </p>
            </li>
            <li className="list-none">
              <strong>7. Conclusão</strong>
            </li>
            <li>
              <p>
                7.1. Este Termo constitui o acordo integral entre você e Nós no que diz respeito ao uso de nosso
                conteúdo e a proibição de scraping não autorizado. Eles substituem todas as comunicações anteriores ou
                contemporâneas, escritas ou orais.
              </p>
            </li>
            <li>
              <p>
                7.2. Este Termo é regido pelas leis do Brasil, respeitadas todas as demais legislações e tratados
                internacionais dos quais o Brasil participa, e quaisquer disputas decorrentes ou relacionadas a eles
                serão submetidas à jurisdição exclusiva dos tribunais dessa jurisdição.
              </p>
            </li>
            <li>
              <p>
                Ao aceitar esses termos, você reconhece que entendeu e concorda em respeitar as regras e diretrizes
                relativas ao uso de nosso conteúdo e à proibição de scraping não autorizado. O não cumprimento destes
                termos pode resultar em consequências legais.
              </p>
            </li>
          </ul>
        </div>
      </PolicyPage>
    </>
  );
}

export default AntiScrapingTerms;
